module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-02-ad34f303bd0ca4c1f164fad4d9cc58cf.svg";